/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  CreateMappingElementMutationRequest,
  CreateMappingElementMutationResponse,
} from "../types/CreateMappingElement.ts"
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { mutationOptions, useMutation } from "@tanstack/react-query"

export const createMappingElementMutationKey = () =>
  [{ url: "/v1/client-settings/create-mapping-element" }] as const

export type CreateMappingElementMutationKey = ReturnType<
  typeof createMappingElementMutationKey
>

/**
 * @summary Create a mapping element
 * {@link /v1/client-settings/create-mapping-element}
 */
export async function createMappingElement(
  data: CreateMappingElementMutationRequest,
  config: Partial<RequestConfig<CreateMappingElementMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    CreateMappingElementMutationResponse,
    ResponseErrorConfig<Error>,
    CreateMappingElementMutationRequest
  >({
    method: "POST",
    url: `/v1/client-settings/create-mapping-element`,
    data: requestData,
    ...requestConfig,
  })
  return res
}

export function createMappingElementMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<CreateMappingElementMutationRequest>> & {
    client?: Client
  } = {}
) {
  const mutationKey = createMappingElementMutationKey()
  return mutationOptions<
    ResponseConfig<CreateMappingElementMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: CreateMappingElementMutationRequest },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return createMappingElement(data, config)
    },
  })
}

/**
 * @summary Create a mapping element
 * {@link /v1/client-settings/create-mapping-element}
 */
export function useCreateMappingElement<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<CreateMappingElementMutationResponse>,
      ResponseErrorConfig<Error>,
      { data: CreateMappingElementMutationRequest },
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig<CreateMappingElementMutationRequest>> & {
      client?: Client
    }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey =
    mutationOptions.mutationKey ?? createMappingElementMutationKey()

  const baseOptions = createMappingElementMutationOptions(
    config
  ) as UseMutationOptions<
    ResponseConfig<CreateMappingElementMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: CreateMappingElementMutationRequest },
    TContext
  >

  return useMutation<
    ResponseConfig<CreateMappingElementMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: CreateMappingElementMutationRequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<CreateMappingElementMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: CreateMappingElementMutationRequest },
    TContext
  >
}
